import { render } from "./TournamentRoomsView.vue?vue&type=template&id=41a664f4"
import script from "./TournamentRoomsView.vue?vue&type=script&lang=js"
export * from "./TournamentRoomsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__